import { render } from "./ErrorComponent.vue?vue&type=template&id=ed643ecc&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"

import "./ErrorComponent.vue?vue&type=style&index=0&id=ed643ecc&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed643ecc"]])

export default __exports__